import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Tailwind 클래스를 합칩니다. 뒤에 온 클래스가 앞의 같은 계열을 이깁니다.
 *
 * 🔴 `tailwind-merge` 는 **v2 계열**을 씁니다. v3 는 Tailwind CSS v4 전용이라
 *    이 프로젝트(Tailwind 3.4)에서는 충돌 해소 규칙이 어긋납니다.
 *    (출처: https://github.com/dcastil/tailwind-merge — "if you use Tailwind v3,
 *     use tailwind-merge v2.6.0")
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
